import { render, staticRenderFns } from "./IndexPanel.vue?vue&type=template&id=2a9c5821&scoped=true&"
import script from "./IndexPanel.vue?vue&type=script&lang=js&"
export * from "./IndexPanel.vue?vue&type=script&lang=js&"
import style0 from "./IndexPanel.vue?vue&type=style&index=0&id=2a9c5821&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c5821",
  null
  
)

export default component.exports